import { z } from 'zod';
export const duelStatusSchema = z.enum(['active', 'locked', 'partial', 'resolved', 'cancelled']);
export const positionSchema = z.enum(['GK', 'DEF', 'MID', 'FWD']);
export const scopeSchema = z.enum(['duels', 'captain', 'ai']);
